import { call, takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getSelectedItem } from '../selectors'
import { IItem } from '../store/timeline.types'
import { TimelineConstants } from '../store/timeline.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setTitrateState } from '../../procedures/titrate/store/titrate.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setTitrateProcedureItem() {
  const selectedItem: IItem = yield select(getSelectedItem)
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) {
    return
  }
  try {
    if (selectedItem) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const titrateState = pcrDoc.patient.titrateStateList?.find((isState) => {
        if (selectedItem.labelHeader) {
          isState.time = selectedItem?.labelHeader
        }
        return isState.key === selectedItem.key
      })
      yield put(setTitrateState(titrateState))
    }
  } catch (e) {
    yield put(throwPcrException(`setTitrateProcedureItem() error: ${e}`))
  }
}

export function* setTitrateProcedureItemSaga() {
  yield takeLatest([TimelineConstants.SET_TITRATE_PROCEDURE_ITEM], performWithMutexHOG, setTitrateProcedureItem)
}
